import { createContext, useContext, useMemo, useState } from 'react';
import LoadBoundary from '../LoadBoundary';

const ModalContext = createContext({});

// eslint-disable-next-line react/prop-types
const ModalRenderer = ({ children }) => {
  const [nodes, setNodes] = useState([]);

  function renderModal(node) {
    setNodes(prev => [...prev, node]);
  }

  function unmountModal(node) {
    setNodes(prev => prev.filter(n => n !== node));
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const ctx = useMemo(() => ({ renderModal, unmountModal }), []);

  return (
    <ModalContext.Provider value={ctx}>
      {children}
      {nodes}
    </ModalContext.Provider>
  );
};

function useModalContext() {
  return useContext(ModalContext);
}

export default ModalRenderer;
export { useModalContext };
